<template>
    <div>
        <div class="form-check" v-if="preferred_currency === 'zar'">
            <input v-model="payment_method" class="form-check-input" type="radio" name="exampleRadios" id="eft" value="eft"  checked @change="$emit('input', 'zar')">
            <label class="form-check-label" for="eft">
                <img class="img-thumbnail" width="50" src="/img/eft.png" alt="">EFT from a South African Bank
            </label>
        </div>
        <div class="form-check" v-if="preferred_currency === 'zar'">
            <input v-model="payment_method" class="form-check-input" type="radio" name="exampleRadios" id="cc"  value="cc">
            <label class="form-check-label" for="cc">
                <img class="img-thumbnail" width="50" src="/img/cc.png" alt="">Credit Card Payment
            </label>
        </div>
        <div v-if="payment_method === 'cc' && preferred_currency === 'zar'">
        <credit-card-types v-model="credit_card_type"/>
        </div>
        <div class="form-check" v-if="preferred_currency === 'usd'">
            <input v-model="payment_method" class="form-check-input" type="radio" name="exampleRadios" id="paypal"  value="paypal" @change="$emit('input', 'usd')" :checked="preferred_currency === 'usd'">
            <label class="form-check-label" for="paypal">
                <img class="img-thumbnail" width="50" src="/img/paypal.png" alt="">PayPal
            </label>
        </div>

    </div>
</template>

<script>
    import CreditCardTypes from "./CreditCardTypes";
    import CurrencyConversionHover from "./CurrencyConversionHover";

    export default {
        name: "PaymentMethod",
        components: {
            CreditCardTypes,
            CurrencyConversionHover
        },
        props: {
            preferred_currency: String
        },
        data: () => ({
            payment_method: '',
            credit_card_type: ''
        }),
        methods: {
          decideToShowAlert() {
              switch (this.credit_card_type) {
                  case "amex":
                      this.showAlert();
                      this.$emit('input', 'usd');
                      break;
                  case "visa":
                  case "mastercard":
                  case "discover":
                      this.$emit('input', 'zar');
                      break;
              }
          },
          showAlert() {
              this.$swal.fire({
                  icon: 'warning',
                  title: 'Heads Up...',
                  html: 'Unfortunately our preferred payment partner, PayFast does not support American Express (AMEX) Credit Card payments <br><br> ' +
                      'PayPal does, but only transacts in United States Dollars. Since you have chosen to donate using Rands we will automatically convert the amount you wish to donate into dollars for you. <br><br>' +
                      'Just bear that in mind when you are at the final checkout stage that you will see the dollar equivalent of your chosen donation amount.',
              });
          }
        },
        watch: {
            credit_card_type: 'decideToShowAlert'
        }
    }
</script>

<style scoped>

</style>
